import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Modal,
  Toast,
} from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faTimes,
  faTimesCircle,
} from "@fortawesome/pro-light-svg-icons";
import { faArrowLeft, faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { InnerLayoutButtons } from "../";
import {
  manageCensusStore,
  setManageCensusFlow,
  setManageCensusToastInfo,
  getCensusDetailsAction,
} from "../../contexts";
import { useHistory } from "react-router";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  ALL_MANAGE_CENSUS_ROUTES,
  MANAGE_CENSUS_ROUTES,
  MANAGE_TRANSFER_ROUTES,
  ROUTES,
  manageCensusFormNames,
  apiErrors,
  getPathWithParam,
  FLOW_TYPES,
  getAdvancedPathWithParam,
} from "../../utils";
import { useFormikContext } from "formik";
import RouteLeavingGuard from "../RouteLeavingGuard";
import data from "../../containers/Mapper/MapAndTransform/sampleData";
import WarningModal from "../WarningModal";

const ManageCensusLayout = ({
  children,
  buttons = [],
  tabs,
  pageFlow,
  layoutHeader,
  customBreadCrumbs,
  history,
  blockNavigation,
  blockCensusNavigation,
  requestOptions = [],
  disableRequestOptions,
  transactionStatus,
  transaction,
}) => {
  const [showError, setShowError] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [inProgress, setInProgress] = useState();
  const { state, dispatch } = useContext(manageCensusStore);
  const censusName = get(
    state,
    `${manageCensusFormNames.ELIGIBILITY_PROCESS}.censusName`
  );
  const { censusId, flow } = useRouterParams();
  const { showToast, toastMessage } = state;
  const {
    isSubmitting,
    dirty,
    resetForm,
    setSubmitting,
  } = useFormikContext() || { dirty: false };
  const apiError = get(state, "api.error", {});
  const apiData = get(state, "api.data", {});
  const menuDetails = find(ALL_MANAGE_CENSUS_ROUTES, (item) => {
    if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
      return true;
    }
    return false;
  });

  useDeepEffect(() => {
    if (isEmpty(apiData) && censusId) {
      dispatch(getCensusDetailsAction(censusId, dispatch, state));
      dispatch(setManageCensusFlow({ flow, censusId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [censusId]);

  useDeepEffect(() => {
    if (transaction == "withdrawal") {
      if (transactionStatus == "Request In Progress") setInProgress(true);
      else setInProgress(false);
    }
  }, [transaction, transactionStatus]);

  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const breadCrumOptions = [
    {
      label: "Home",
      link: ROUTES.HOME,
    },
    {
      label: "Manage Employees",
      link: ROUTES.MANAGE_EMPLOYEE,
    },
  ];

  if (censusName) {
    breadCrumOptions.push({
      label: censusName,
      link: getPathWithParam({
        path: MANAGE_CENSUS_ROUTES.ELIGIBILITY,
        pathParam: [flow, censusId],
      }),
    });
  }

  const breadCrumbsFromMenuDetails = get(menuDetails, "breadCrumbs", []);
  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  } else if (!isEmpty(breadCrumbsFromMenuDetails)) {
    breadCrumOptions.push(
      ...breadCrumbsFromMenuDetails.map((item) => ({
        ...item,
        link: getPathWithParam({
          path: item.link,
          pathParam: [flow, censusId],
        }),
      }))
    );
  }

  const onRefresh = () => {
    if (resetForm) {
      resetForm();
      setSubmitting(false);
    }
  };

  const onHide = () => {
    setModalVisible(false);
  };

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];
  //const history = useHistory();
  const employeeNavigate = () => {
    history.push(
      getAdvancedPathWithParam({
        path: ROUTES.MANAGE_EMPLOYEE,
        // pathParam: [FLOW_TYPES.ADD],
      })
    );
  };

  return (
    <div
      style={{ marginLeft: "-30px" }}
      className="d-flex flex-column manage-company layout-height h-100 pt-3"
    >
      <div className="d-flex flex-column layout-header">
        <div className="d-flex align-items-center">
          <div className="d-flex">
            {/* <div
              className="link blue-small mt-1"
              style={{ cursor: "pointer" }}
              onClick={employeeNavigate}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={{ cursor: "pointer" }}
              />{" "}
              Back
            </div>
            <div className="vertical-line-header"></div> */}
            {/* <Breadcrumb>
              {breadCrumOptions.slice(-4).map((item, index) => (
                <Breadcrumb.Item key={index}>
                  <Link to={item.link}>{item.label}</Link>
                </Breadcrumb.Item>
              ))}
            </Breadcrumb> */}
            <h5>{layoutHeader || get(menuDetails, "contentHeader", "")}</h5>
          </div>
          <div className="d-flex align-items-center justify-content-center tab-wrapper">
            {tabs}
          </div>
          <div className="ml-auto">
            <InnerLayoutButtons
              menu="employees"
              subMenu={get(menuDetails, "id", "")}
              buttonsList={buttons}
              flow={pageFlow}
            />
          </div>
          {get(menuDetails, "contentHeader", "") == "Transactions" &&
            (disableRequestOptions ? (
              <Button onClick={() => setModalVisible(true)}>New Request</Button>
            ) : (
              <DropdownButton
                title="New Request"
                style={{ width: "300px" }}
                align="end"
                id="dropdown-menu-align-end"
                className={"request-dropdown"}
              >
                {requestOptions.map((data, index) => (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item>
                      <Link
                        to={getPathWithParam({
                          path: data.path,
                          pathParam: data.pathParam,
                        })}
                      >
                        {data.label}
                      </Link>
                    </Dropdown.Item>
                  </>
                ))}
              </DropdownButton>
            ))}
          {showError && (
            <div
              className={`error-banner d-flex align-items-center ${
                (showError && "enable") || ""
              }`}
            >
              <div>
                <div className="error-heading">{errorData.heading}</div>
                <div className="error-reason">{errorData.reason}</div>
              </div>
              <div className="ml-auto">
                <Button variant="link" onClick={() => setShowError(false)}>
                  <FontAwesomeIcon
                    icon={faTimes}
                    color="#212529"
                    style={{ fontSize: "1.5rem" }}
                  />
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="layout-content h-100 overflow-auto">{children}</div>
      <Toast
        onClose={() =>
          dispatch(
            setManageCensusToastInfo({
              showToast: false,
              toastMessage: "",
            })
          )
        }
        show={showToast}
        style={{
          position: "fixed",
          top: "10rem",
          right: "2rem",
          zIndex: "100",
        }}
        delay={3000}
        autohide
      >
        <Toast.Body className="success-toast-align">
          <div className="mr-2">
            {showToast ? (
              <FontAwesomeIcon icon={faCheckCircle} color="#3BB54A" size="lg" />
            ) : (
              ""
            )}
          </div>
          <div>{toastMessage}</div>
          <div className="ml-2">
            {showToast ? (
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000000"
                size="md"
                onClick={() =>
                  dispatch(
                    setManageCensusToastInfo({
                      showToast: false,
                      toastMessage: "",
                    })
                  )
                }
              />
            ) : (
              ""
            )}
          </div>
        </Toast.Body>
      </Toast>
      <Modal show={modalVisible} onHide={onHide}>
        <Modal.Body
          style={{
            borderTop: "5px solid #f94f50",
          }}
        >
          <div className="d-flex">
            <div className="pr-3">
              <FontAwesomeIcon
                icon={faExclamationCircle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div>
              {inProgress ? (
                <p>
                  Kindly complete or delete the pending transaction to raise a
                  new request.
                </p>
              ) : (
                <p>
                  There is a transaction in {transactionStatus} state, kindly
                  wait until the transaction is completed.
                </p>
              )}
              <Button onClick={onHide}>Ok</Button>
            </div>
            <div className="close-buttonWarningModal text-right">
              <FontAwesomeIcon
                icon={faTimes}
                color="#000"
                onClick={onHide}
                size="1x"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <RouteLeavingGuard
        when={!isSubmitting && (dirty || !!blockNavigation)}
        navigate={(path) => history.push(path)}
        onRefresh={onRefresh}
        blockNavigation={blockCensusNavigation}
      />
    </div>
  );
};

export default withRouter(ManageCensusLayout);
